module.exports = ['$location', '$timeout', function ($location, $timeout) {
    "use strict";
    //
    // UrlWatcherService
    //
    return class UrlWatcherService {
        constructor(scope, options, properties = [], defaults = {}, locationUpdated = angular.noop) {
            this.scope = scope;
            this.options = options;
            this.properties = properties;
            this.defaults = defaults;
            this.locationUpdated = locationUpdated;
            this.bindEvents();

            // clean up the old url values on controller change
            scope.$on("$destroy", function(){
                for (var key in options) {
                    delete options[key];
                }
            });
        }

        extractReportOptionsFromLocation() {
            // Parse location attributes
            var params = $location.search();
            angular.extend(this.options, this.defaults, params);

            // Call the callback
            this.locationUpdated();
        }

        clearOption(option){
            $location.search(option, undefined);
            delete this.scope.reportOptions[option];
        }

        setOption(option, value){
            $location.search(option, value);
            this.scope.reportOptions[option] = value;
        }

        resetOptionToDefault(option){
            $location.search(option, this.defaults[option]);
            this.scope.reportOptions[option] = this.defaults[option];
        }

        bindEvents() {
            var _this_url_watcher = this;

            this.scope.$on("$locationChangeSuccess", () => {
                this.extractReportOptionsFromLocation()
            });

            this.scope.$watchCollection('reportOptions', function (newVal, oldVal) {

                var changes = {};
                var changed = false;

                // Skip first initialization
                if (newVal) {
                    for (var key in newVal) {
                        var isMoment = moment.isMoment(newVal[key]);
                        if (isMoment) {
                            if (moment(newVal[key]).isValid() && !moment(newVal[key]).isSame(moment(oldVal[key]))) {

                                $location.search(key, moment(newVal[key]).format(_this_url_watcher.scope.$root.dateFormat.moment_url));
                                changed = true;
                            }
                        } else {
                            if (newVal[key] != oldVal[key]) {
                                changes[key] = {oldVal: oldVal[key], newVal: newVal[key]};
                                $location.search(key, newVal[key]);
                                changed = true;
                            }
                        }
                    }
                }

                if (oldVal) {
                    for (var key in oldVal) {
                        if (newVal[key] === undefined) {
                            changes[key] = {oldVal: oldVal[key], newVal: undefined};
                            $location.search(key, undefined);
                            changed = true;
                        }
                    }
                }

                if (changed) {
                    _this_url_watcher.optionsChanged(changes);
                }

            }, true);
        }
    };
}];
